import { createCategory } from './utils';

export const ANALYTICS_CATEGORY_PATH = '/analytics';
export const ANALYTICS_STATISTICS_PATH = `${ANALYTICS_CATEGORY_PATH}/statistics`;

export const analyticsCategory = createCategory({
  title: 'analytics',
  icon: 'graph',
  path: ANALYTICS_CATEGORY_PATH,
});

export const OVERVIEW_CATEGORY_PATH = '/overview';

export const OVERVIEW_DASHBOARD_PATH = `${OVERVIEW_CATEGORY_PATH}/dashboard`;
export const OVERVIEW_NEWS_PATH = `${OVERVIEW_CATEGORY_PATH}/news`;
export const OVERVIEW_NEWS_ITEM_PATH = `${OVERVIEW_NEWS_PATH}/item`;
export const overviewCategory = createCategory({
  path: OVERVIEW_CATEGORY_PATH,
  title: 'overview',
  icon: 'user',
});

export const LINKS_CATEGORY_PATH = '/links-and-creatives';
export const linksAndCreativesCategory = createCategory({
  path: LINKS_CATEGORY_PATH,
  title: 'linksAndAdCreatives',
  icon: 'link',
});

export const WHITE_LABELS_CATEGORY_PATH = '/white-labels';
export const whiteLabelsCategory = createCategory({
  title: 'whitelabels',
  icon: 'layout',
  path: WHITE_LABELS_CATEGORY_PATH,
});

export const PAYOUTS_CATEGORY_PATH = '/payouts';
export const payoutsCategory = createCategory({
  path: PAYOUTS_CATEGORY_PATH,
  title: 'payouts',
  icon: 'coin',
});

export const REFERRAL_PROGRAM_CATEGORY_PATH = '/referral-program';
export const REFERRAL_PROGRAM_MODELS_PATH = `${REFERRAL_PROGRAM_CATEGORY_PATH}/referral-models`;
/** @deprecated */ export const REFERRAL_PROGRAM_MODELS_DEP_PATH = `${REFERRAL_PROGRAM_CATEGORY_PATH}/models`;
export const REFERRAL_PROGRAM_AFFILIATES_PATH = `${REFERRAL_PROGRAM_CATEGORY_PATH}/referral-affiliates`;
export const referralProgramCategory = createCategory({
  title: 'referralProgram',
  icon: 'userAdd',
  path: REFERRAL_PROGRAM_CATEGORY_PATH,
});

export const SERVICE_CATEGORY_PATH = '/service';
/** @deprecated */ export const SERVICE_POSTBACK_LOG_PATH = `${SERVICE_CATEGORY_PATH}/postback-log`;
export const SERVICE_POSTBACKS_LOG_PATH = `${SERVICE_CATEGORY_PATH}/postbacks-log`;
export const RABBIT_ARCHIVER_LOG_PATH = `${SERVICE_CATEGORY_PATH}/rabbit-archiver`;
export const serviceCategory = createCategory({
  path: SERVICE_CATEGORY_PATH,
  title: 'service',
  icon: 'gearwheel',
});

export const DOCUMENTATION_CATEGORY_PATH = '/documentation';
export const documentationCategory = createCategory({
  title: 'documentation',
  icon: 'book',
  path: DOCUMENTATION_CATEGORY_PATH,
});
export const DOCUMENTATION_VIDEO_TUTORIALS_PATH = `${DOCUMENTATION_CATEGORY_PATH}/video-tutorials`;
export const DOCUMENTATION_POSTBACK_PARAMS_PATH = `${DOCUMENTATION_CATEGORY_PATH}/postback-guide`;
export const DOMAIN_CHECKER_CATEGORY_PATH = `${SERVICE_CATEGORY_PATH}/domain-checker`;
export const SERVICE_API_DOMAIN_PATH = `${SERVICE_CATEGORY_PATH}/api-domain`;
export const FORBIDDEN_DOMAINS_PATH = `${SERVICE_CATEGORY_PATH}/forbidden-domains`;
export const CONFIGURATION_PATH = `${SERVICE_CATEGORY_PATH}/configuration`;
export const PIRATE_DOMAINS_PATH = `${SERVICE_CATEGORY_PATH}/pirate-domains`;
export const DOCUMENTATION_LINKS_CREATIVES_PARAMS_PATH = `${DOCUMENTATION_CATEGORY_PATH}/links-creatives-params`;
export const DOCUMENTATION_API_PATH = `${DOCUMENTATION_CATEGORY_PATH}/api`;
export const DOCUMENTATION_MODELS_AGGREGATORS_SWAGGER_PATH = `${DOCUMENTATION_API_PATH}/?tab=models_api_for_aggregators`;
export const DOMAIN_MANAGEMENT_PATH = `${SERVICE_CATEGORY_PATH}/domain-management`;
export const CLOUDFLARE_PATH = `${SERVICE_CATEGORY_PATH}/cloudflare`;

// public paths
export const LOGIN_PATH = '/login';
export const REGISTRATION_PATH = '/sign-up';
export const VERIFICATION_PATH = '/verification';
export const PAYOUT_CONFIRMATION_PATH = '/payout-confirmation';
export const RECOVERY_PATH = '/recovery';
export const FORBIDDEN_PATH = '/403';
export const TERMS_PATH = '/terms';
export const PRIVACY_POLICY_PATH = '/privacy-policy';
export const COOKIES_POLICY_PATH = '/cookies-policy';
export const FAQ_PATH = '/faq';
export const TRUSTED_PARTNERS_PATH = '/trusted-partners';
export const MAIN_PAGE = '/';

export const COMMON_AFFILIATE_PAGES = [
  MAIN_PAGE,
  FAQ_PATH,
  COOKIES_POLICY_PATH,
  TRUSTED_PARTNERS_PATH,
  COOKIES_POLICY_PATH,
  PRIVACY_POLICY_PATH,
  TERMS_PATH,
];

// PLOP_APPEND_PAGE_ROUTE_URL_PATTERN
